    import { Loader } from "@googlemaps/js-api-loader";
    export async function initPartnerMap() {

        const loader = new Loader({
            apiKey: Ajax.googleApi,
            version: "weekly",
        });

        loader.load().then(async () => {
           
            let allowedBounds = new google.maps.LatLngBounds();
            var latlng = new google.maps.LatLng(55, -5);

            let map
            var mapOptions = {
                zoom: 6,
                minZoom: 5,
                center: latlng,
                mapTypeControl: false,
                fullscreenControl: false,
                region: "uk",
                styles: [
                    {
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#f5f5f5"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.icon",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": "#f5f5f5"
                        }
                      ]
                    },
                    {
                      "featureType": "administrative.land_parcel",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#bdbdbd"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#eeeeee"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#e5e5e5"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    },
                    {
                      "featureType": "road",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#ffffff"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#dadada"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    },
                    {
                      "featureType": "transit.line",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#e5e5e5"
                        }
                      ]
                    },
                    {
                      "featureType": "transit.station",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#eeeeee"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#c9c9c9"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    }
                  ]
            };
            map = new google.maps.Map(
            document.getElementById("partner-map"),
            mapOptions
            )
            
            // fetch partners and create markers
            if(map) {
                map.markers = [];
                const partners = await fetchPartners();
                // itterate each partner
                for (const [partner_id, partner] of Object.entries(partners.data)) {
                    // get partner object
                    console.log(partner)
                    for(const [key, data] of Object.entries(partner)) {
                        //console.log(data[0].featured_image)
                        let partner = data
                        let lat = partner.map.lat
                        let long = partner.map.lng
                        //let markerLoc = convertGeoLocToPix(lat, long)
    
                        createPartnerMapMarker(partner, map)
                    }
                }
            }
        }); 

    }

    /**
     * Convert Geolocation to pixels
     * 
     * Calculates geoloaction as pixels for position on SVG map
     * @param {*} latitude 
     * @param {*} longitude 
     * @returns {x, y}
     */

    // Convert Geolocation from Google Maps to Pixel X, Y positioning
    function convertGeoLocToPix(latitude, longitude) {
        // mapWidth, // in pixels
        // mapHeight, // in pixels
        // mapLngLeft, // in degrees. the longitude of the left side of the map (i.e. the longitude of whatever is depicted on the left-most part of the map image)
        // mapLngRight, // in degrees. the longitude of the right side of the map
        // mapLatBottom // in degrees.  the latitude of the bottom of the map
        let mapWidth = 1000, 
            mapHeight = 1870, 
            mapLngLeft = -8.176727, 
            mapLngRight = 1.739236, 
            mapLatBottom = 49.961284

        const mapLatBottomRad = mapLatBottom * Math.PI / 180
        const latitudeRad = latitude * Math.PI / 180
        const mapLngDelta = (mapLngRight - mapLngLeft)

        const worldMapWidth = ((mapWidth / mapLngDelta) * 360) / (2 * Math.PI)
        const mapOffsetY = (worldMapWidth / 2 * Math.log((1 + Math.sin(mapLatBottomRad)) / (1 - Math.sin(mapLatBottomRad))))

        const x = (longitude - mapLngLeft) * (mapWidth / mapLngDelta)
        const y = mapHeight - ((worldMapWidth / 2 * Math.log((1 + Math.sin(latitudeRad)) / (1 - Math.sin(latitudeRad)))) - mapOffsetY)

        return {x, y} // the pixel x,y value of this point on the map image
    }

    /**
     * Creat Map Marker
     * 
     * Creates marker on partner map representing partner location
     * @param {*} elem 
     * @param {*} partner 
     * @param {*} x 
     * @param {*} y 
     */

    function createPartnerMapMarker(partner, map) {

        //console.log(partner);

        var lat = partner.map.lat;
        var lng = partner.map.lng;
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };
        var partner_id = partner.post_id;
    
        var icon = {
            url: 'data:image/svg+xml;utf-8, <svg viewBox="0 0 24 34" xmlns="http://www.w3.org/2000/svg" width="24" height="34" background-color="%23000000"><path d="M0 12C0 21.7 12 33.7 12 33.7 12 33.7 24 21.7 24 12 24 5.4 18.6 0 12 0 5.4 0 0 5.4 0 12Z" fill="%23131F54"/><path d="M7.3 12C7.3 9.4 9.4 7.3 12 7.3 14.6 7.3 16.7 9.4 16.7 12 16.7 14.6 14.6 16.7 12 16.7 9.4 16.7 7.3 14.6 7.3 12Z" fill="%23fff"/></svg>',
        };
        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: icon,
            partner: partner_id,
        });
        map.markers.push(marker);

        map.markers.forEach(marker => {
            //console.log(marker);
             google.maps.event.addListener(marker, 'click', function () {
                renderPartnerCard(marker.partner)
            });
        });
        
        // close partner card
        document.addEventListener('click', function(e){
            if(e.target && e.target.id == 'close-partner') {
                closePartnerCard()
             }
         });
        
    }


    /**
     * fetch partners
     * @returns results
     */
    async function fetchPartners() {

        let formData = new FormData();
        // add action and ajax nonce to formData
        formData.set('action', 'fetch_partners')
        formData.set('nonce', Ajax.nonce)

        // collect form params
        const params = new URLSearchParams(formData);

        let results

       await fetch(Ajax.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
            },
            body: params
        }).then((response) => {
            //console.log(response)
            return response.text();
        }).then((data) => {
            results = JSON.parse(data)
           // console.log(results)
        }).catch((err) => {
            //console.log(err)
            return err
        });

        return results
    }
    
    /**
     * Render Partner card
     * @param {*} $partner_id 
     */

    function renderPartnerCard(partner_id) {

        let partnerCard = document.getElementById('partner-card')
        let formData = new FormData();

        // add action and ajax nonce to formData
        formData.set('action', 'fetch_partner')
        formData.set('nonce', Ajax.nonce)
        formData.set('partner_id', partner_id)

        // collect form params
        const params = new URLSearchParams(formData);

        partnerCard.innerHTML = '<div class="ajaxLoader"><div class="dots"><div></div><div></div><div></div></div></div>';

        fetch(Ajax.ajaxurl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
          },
          body: params
        }).then((response) => {
          //console.log(response)
          return response.text();

        }).then((html) => {
          partnerCard.innerHTML = html;
          partnerCard.classList.add('show')

        }).catch((err) => {

            // There was an error
            return err

        });

    }

    /**
     * Close Partner Card
     * 
     * Closes open card and replaces partnerCard div content
     * This can be empty content or some default content.
     */

    function closePartnerCard() {
        //console.log('card close')
        let partnerCard = document.getElementById('partner-card')
        partnerCard.innerHTML = null
    }

    /**
     * Partner Map Zoom In
     * 
     * Inreases current map scaled by .1
     * minimum map scale set at 1.3
     */

    function partnerMapZoomIn() {
        const map = document.getElementById('partnerMap');
        let matrix = window.getComputedStyle(map).transform;
        let matrixArray = matrix.replace("matrix(", "").split(",");
        let scale = parseFloat(matrixArray[0])

        let curTrans = map.style.transform;
        let regex = /scale\([0-9|\.]*\)/;;

        let newScale

        // make sure its at least 1.3 or above
        if(scale >= 1.3) {
            newScale = (scale + 0.2)
        } else if(scale == 1.3) {
            newScale = 1.3
        } else {
            newScale = 1.3
        }

        let newScaleString = 'scale(' + newScale + ')';
        let newTrans = curTrans.replace(regex, newScaleString);

        map.style.transform = newTrans

    }

    /**
     * Partner Map Zoom Out
     * 
     * Decreases current map scaled by .1
     * minimum map scale set at 1.3
     */

    function partnerMapZoomOut() {
        const map = document.getElementById('partnerMap');
        let matrix = window.getComputedStyle(map).transform;
        let matrixArray = matrix.replace("matrix(", "").split(",");
        let scale = parseFloat(matrixArray[0])

        let curTrans = map.style.transform;
        let regex = /scale\([0-9|\.]*\)/;;

        let newScale

        // make sure its at least 1.3 or above
        if(scale >= 1.3) {
            newScale = (scale - 0.2)
        } else if(scale == 1.3) {
            newScale = 1.3
        } else {
            newScale = 1.3
        }

        let newScaleString = 'scale(' + newScale + ')';
        let newTrans = curTrans.replace(regex, newScaleString);

        map.style.transform = newTrans
    }

    /**
     * Partner Map Resets
     * 
     * Resets map scale to 1.3
     */

    function partnerMapReset() {
        const map = document.getElementById('partnerMap');
        map.style.transform = 'scale(1.3) translateX(0) translateY(-10%)'
    }
